/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { BoundsHelper } from '../../../helper/maps/bound';
import { GeoLocationPoint } from '../../../model';

export function useFitBounds(
  geoLocationPoints: GeoLocationPoint<Location>[],
  maps?: google.maps.Map
) {

  useEffect(() => {
    if (!maps || !geoLocationPoints.length) {
      return;
    }

    const bound = new BoundsHelper();
    geoLocationPoints.forEach(point => {
      const [lng, lat] = point.geometry.coordinates;
      bound.add(lat, lng);
    });
    maps.fitBounds(bound.getBounds());

  }, [geoLocationPoints]);
}
